import type { FunctionComponent } from "react";

import { ImageSize } from "scmp-app/components/article/article-leading/article-leading-images/enums";
import type { Props as GenericArticleProps } from "scmp-app/components/article/article-render/generic-article";

import { StyledGenericArticle } from "./styles";

export type Props = GenericArticleProps;

export const PhotoEssayAndLongReadArticle: FunctionComponent<GenericArticleProps> = props => (
  <StyledGenericArticle
    {...props}
    leadingProps={{
      responsiveVariants: {
        desktopUp: ImageSize["landscape250x99"],
        mobileUp: ImageSize["1020x680"],
        tabletUp: ImageSize["landscape250x99"],
      },
    }}
  />
);

PhotoEssayAndLongReadArticle.displayName = "PhotoEssayAndLongReadArticle";
